import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import queryString from 'query-string';

import config from '../config';
import { createValueStore } from '../hooks/useLocalStorage';

const { api } = config;

// axios 1.15 changed default array param serialization in a way the back-end's
// qs parser can't decode — see VER-563 fix c4d811b05. Set the serializer on the
// instance so every GET inherits arrayFormat: 'repeat' by default rather than
// each new endpoint needing to remember to opt in.
const axiosInstance = axios.create({
  baseURL: api.baseUrl,
  headers: {
    'X-User-Type': 'admin'
  },
  paramsSerializer: (params) => queryString.stringify(params, { arrayFormat: 'repeat' }),
});

setupCache(axiosInstance, {
  methods: ['get'],
  headerInterpreter: (headers) => {
    const cacheControl = headers['cache-control'];
    const maxAgeMatch = cacheControl.match(/max-age=(\d+)/);
    
    if (maxAgeMatch) {
      return parseInt(maxAgeMatch[1], 10) * 1000; 
    }
    
    return 'not enough headers';
  },
  cachePredicate: (response) => {
    return !!response.headers['cache-control'];
  },
});

// Intercepting the request for adding headers and common query params
const requestHandler = request => {
  const accessTokenCache = createValueStore('userToken');
  // Modify request here
  const userToken = accessTokenCache.get();
  if (userToken) {
    request.headers.Authorization = `Bearer ${userToken}`
  }

  const { url } = request;
  if (url === "/user/password-reset") {
    const resetTokenCache = createValueStore('resetToken');
    const resetToken = resetTokenCache.get();
    if (resetToken) {
      request.headers.Authorization = `Bearer ${resetToken}`
    }
  }

  return request;
};

axiosInstance.interceptors.request.use(request => requestHandler(request));

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    console.error(error);
    if (!!error.response?.data.error && error.response.data.message.toLowerCase() === 'session timed out or invalid') {
      const accessTokenCache = createValueStore('userToken');
      accessTokenCache.remove();
    }
    return Promise.reject({ ...error });
  }
);

export default axiosInstance;
